<template>
	<div class="app--engagement-header" :class="classes">
		<div v-if="signed" class="app--engagement-message-locked text--size-default text--font-primary">
			<div>{{ trans('documents.not_allowed_message') }}</div>
		</div>
		<div v-if="pageVisibleOnlyInPreview"
			 class="app--engagement-message-locked text--size-default text--font-primary">
			<div>{{ trans('visibility.page.preview') }}</div>
		</div>
		<div class="progress" :class="{ 'active': progress > 0 }">
			<div class="bar" :style="{ width: progress + '%' }"></div>
		</div>
		<div v-if="theme.header.enabled && page" class="title" v-html="macro(page.title)"></div>
		<engagement-popup v-if="popup" :page="page"></engagement-popup>
	</div>
</template>

<script>
import Popup from './helpers/Popup'
import store from '../store'

export default {
	computed: {
		loading() {
			return store.state.loading
		},
		page() {
			return store.state.page
		},
		popup() {
			return this.page && this.page.description && this.page.description.length > 0
		},
		sidebar() {
			return this.theme.sidebar.enabled == true && store.state.auth.authenticated === true
		},
		theme() {
			return store.state.theme
		},
		classes() {
			let c = []
			if (this.theme.header.enabled) {
				c = [
					'visible',
					'bg--header',
					'border--header',
					'text--color-' + this.theme.header.color,
					'text--font-' + this.theme.header.font,
					'text--size-' + this.theme.header.size,
				];
			}
			if (this.theme.header.fixed) {
				c.push('fixed')
			}
			if (this.sidebar) {
				c.push('has-sidebar')
			}

			return c
		},
		signed() {
			return store.getters.signedByAnotherSigner && store.state.preview == false && store.state.complete == false
		},
		pageVisibleOnlyInPreview() {
			return this.page.print_visibility == 'preview' && store.state.preview == true && store.state.complete == false
		}
	},
	data() {
		return {
			handler: null,
			progress: 0
		}
	},
	watch: {
		loading: function (val) {
			if (val === true) {
				this.progress = 1
				this.handler = setInterval(this.advance, 300)
			} else if (val === false) {
				this.progress = 100
				clearInterval(this.handler)
				setTimeout(() => {
					this.progress = 0
				}, 900)
			}
		},
	},
	methods: {
		macro(value) {
			return store.getters['macro'](value)
		},
		advance: function () {
			this.progress = (this.progress + 20 > 100) ? 100 : this.progress + 20
		},
		trans(value) {
			let trans = store.getters.trans(value);
			return trans ? trans : this.$t('front.' + value)
		},
	},
	components: {
		'engagement-popup': Popup
	}
}
</script>
